import {
  DASHBOARD_PATH,
  // CREATE_MERCHANT,
  // IN_UNDERWRITING_PATH,
  // PENDING_PATH,
  // COMPLETE_PATH,
  // CREATE_MERCHANT,
  // IN_UNDERWRITING_PATH,
  // PENDING_PATH,
  // COMPLETE_PATH,
  USERS_LIST_PATH,
  TEAMS_LISTS_PATH,
  // PROFILE_PATH,
  // PROFILE_PATH,
  LEADS_PATH,
  LEADS_CREATE_PATH,
  CALENDAR_SCHEDULE_PATH,
  // SALES_DBA_LISTING,
  ROLES_LIST_PATH,
  ROLES_CREATE_PATH,
  ISSUE_LIST_PAGE,
  USER_PERMISSION,
  // MERCHANT_ACCOUNTS_LIST,
  CONTRACTS_LIST_PATH,
  // DAILY_SUMMARY_LIST_PATH,
  // DAILY_SUMMARY_CREATE_PATH,
  // CALLS_COUNTER_SUMMARY_PATH,
  // LEADS_REPORT_PATH,
  // RECENT_ACTIVITIES_REPORT_PATH,
  CREATE_TEAM,
  MEETING_CREATE_PATH,
  CREATE_USER,
  CUSTOMERS_LIST_PATH,
  CREATE_CUSTOMER,
  CALL_RECORDS_LIST_PATH,
  CALL_RECORDS_CREATE_PATH,
  INVOICES_LIST_PATH,
  INVOICES_CREATE_PATH,
  PAYMENTS_LIST_PATH,
  PAYMENT_ERRORS_LIST_PATH,
  BRANDS_LIST_PATH,
  BRANDS_CREATE_PATH,
  SERVICES_LIST_PATH,
  SERVICES_CREATE_PATH,
  LEAD_QUIZZES_LIST_PATH,
  LEAD_QUIZZES_CREATE_PATH,
  COMPANIES_LIST_PATH,
  COMPANIES_CREATE_PATH,
  TASK_TYPES_LIST_PATH,
  TASK_TYPES_CREATE_PATH,
  TASK_CATEGORIES_LIST_PATH,
  TASK_CATEGORIES_CREATE_PATH,
  TASK_TEMPLATES_LIST_PATH,
  TASK_TEMPLATES_CREATE_PATH,
  TASKS_LIST_PATH,
  TASKS_CREATE_PATH,
  LEAD_REPORT_GENERATE_SALES_PATH,
  LEAD_REPORT_PAYMENT_SUMMARY_PATH,
  LEAD_REPORT_CLIENTS_AS_PER_STATUS_PATH,
  PAYMENT_ACCOUNTS_LIST_PATH,
  PAYMENT_ACCOUNTS_CREATE_PATH,
  ORDER_CREATE_PATH,
  ORDER_LIST_PATH,
  SERVICE_PLANS_LIST_PATH,
  SERVICE_PLANS_CREATE_PATH,
  SERVICE_STATE_PRICES_LIST_PATH,
  SERVICE_STATE_PRICES_CREATE_PATH,
} from "./path";
import { LIST_ROUTE_ANY_PERMISSIONS } from "./resourceListPermissions";

import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
// import CallIcon from '@mui/icons-material/Call';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import PendingActionsIcon from '@mui/icons-material/PendingActions';
// import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ContactsIcon from "@mui/icons-material/Contacts";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import PostAddIcon from "@mui/icons-material/PostAdd";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import SummarizeIcon from '@mui/icons-material/Summarize';
import AssessmentIcon from "@mui/icons-material/Assessment";
// import HistoryIcon from '@mui/icons-material/History';
// import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import EventNoteIcon from "@mui/icons-material/EventNote";
// import GroupsIcon from '@mui/icons-material/Groups';
import SupportIcon from "@mui/icons-material/Support";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import MicIcon from "@mui/icons-material/Mic";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PaymentIcon from "@mui/icons-material/Payment";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import StorefrontIcon from "@mui/icons-material/Storefront";
import HandymanIcon from "@mui/icons-material/Handyman";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CategoryIcon from "@mui/icons-material/Category";
import QuizIcon from "@mui/icons-material/Quiz";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PieChartIcon from "@mui/icons-material/PieChart";

const iconSx = { fontSize: 16 };
const groupIconSx = { fontSize: 20 };

/** Single nav item: { path, label, icon, permission } */
/** Group: { type: 'group', label, icon, children: [item, ...] } */
/** Flat item: { type: 'item', path, label, icon, permission } */

export const sidebarStructure = [
  {
    type: "item",
    path: DASHBOARD_PATH,
    label: "Dashboard",
    icon: <DashboardOutlinedIcon sx={iconSx} />,
    permission: null,
  },

  //    {
  //     type: 'group',
  //     label: 'Reports',
  //     icon: <AssessmentIcon sx={groupIconSx} />,
  //     children: [
  //       { path: CALLS_COUNTER_SUMMARY_PATH, label: 'Calls Counter Summary', icon: <CallIcon sx={iconSx} />, permission: 'report-calls-counter-summary' },
  //       { path: LEADS_REPORT_PATH, label: 'Leads Comments', icon: <ContactsIcon sx={iconSx} />, permission: 'report-leads-comments' },
  //       { path: RECENT_ACTIVITIES_REPORT_PATH, label: 'Recent Activities', icon: <HistoryIcon sx={iconSx} />, permission: 'log-activity-view' },
  //     ],
  // },
  //   {
  //   type: 'group',
  //   label: 'Agent Daily Summary',
  //   icon: <SummarizeIcon sx={groupIconSx} />,
  //   children: [
  //     { path: DAILY_SUMMARY_LIST_PATH, label: 'Call Counters', icon: <SummarizeIcon sx={iconSx} />, permission: 'agentCallReport-list' },
  //     { path: DAILY_SUMMARY_CREATE_PATH, label: 'Add Call Counter', icon: <AddCircleOutlineIcon sx={iconSx} />, permission: 'agentCallReport-create' },
  //   ],
  // },

  // {
  //   type: 'group',
  //   label: 'DBA Management',
  //   icon: <BusinessCenterIcon sx={groupIconSx} />,
  //   children: [
  //     { path: MERCHANT_ACCOUNTS_LIST, label: 'Merchant Accounts', icon: <DescriptionOutlinedIcon sx={iconSx} />, permission: 'dba-list' },
  //     { path: CREATE_MERCHANT, label: 'Add Merchant Account', icon: <AddCircleOutlineIcon sx={iconSx} />, permission: 'dba-create' },
  //     { path: IN_UNDERWRITING_PATH, label: 'Underwriting Applications', icon: <DescriptionOutlinedIcon sx={iconSx} />, permission: 'dba-list' },
  //     { path: PENDING_PATH, label: 'Pending Applications', icon: <PendingActionsIcon sx={iconSx} />, permission: 'dba-list' },
  //     { path: COMPLETE_PATH, label: 'Approved Accounts', icon: <TaskAltIcon sx={iconSx} />, permission: 'dba-list' },
  //     { path: SALES_DBA_LISTING, label: 'Sales Applications', icon: <DescriptionOutlinedIcon sx={iconSx} />, permission: 'dba-sales-list' },
  //   ],
  // },

  {
    type: "group",
    label: "Tasks",
    icon: <EventNoteIcon sx={groupIconSx} />,
    children: [
      {
        path: TASKS_LIST_PATH,
        label: "Tasks",
        icon: <EventNoteIcon sx={iconSx} />,
        permission: "task-list",
      },
      {
        path: TASKS_CREATE_PATH,
        label: "Add task",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "task-create",
      },
    ],
  },
  {
    type: "group",
    label: "Lead reports",
    icon: <AssessmentIcon sx={groupIconSx} />,
    children: [
      {
        path: LEAD_REPORT_GENERATE_SALES_PATH,
        label: " Sales Information",
        icon: <TrendingUpIcon sx={iconSx} />,
        permission: null,
      },
      {
        path: LEAD_REPORT_PAYMENT_SUMMARY_PATH,
        label: "Payment Summary",
        icon: <PaymentIcon sx={iconSx} />,
        permission: null,
      },
      {
        path: LEAD_REPORT_CLIENTS_AS_PER_STATUS_PATH,
        label: "Clients as per status",
        icon: <PieChartIcon sx={iconSx} />,
        permission: null,
      },
    ],
  },
  {
    type: "group",
    label: "Lead Management",
    icon: <ContactsIcon sx={groupIconSx} />,
    children: [
      {
        path: LEADS_PATH,
        label: "Leads",
        icon: <ContactsIcon sx={iconSx} />,
        permission: "lead-list",
      },
      {
        path: LEADS_CREATE_PATH,
        label: "Add Lead",
        icon: <PostAddIcon sx={iconSx} />,
        permission: "lead-create",
      },
      {
        path: LEAD_QUIZZES_LIST_PATH,
        label: "Lead quizzes",
        icon: <QuizIcon sx={iconSx} />,
        permission: "lead-quiz-list",
      },
      {
        path: LEAD_QUIZZES_CREATE_PATH,
        label: "Add lead quiz",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "lead-quiz-create",
      },
      {
        path: CALL_RECORDS_LIST_PATH,
        label: "Call Recordings",
        icon: <MicIcon sx={iconSx} />,
        permission: "call-record-list",
      },
      {
        path: CALL_RECORDS_CREATE_PATH,
        label: "Upload Recording",
        icon: <CloudUploadIcon sx={iconSx} />,
        permission: "call-record-create",
      },
    ],
  },

  // {
  //   type: "group",
  //   label: "Lead reports",
  //   icon: <AssessmentIcon sx={groupIconSx} />,
  //   children: [
  //     {
  //       path: LEAD_REPORT_GENERATE_SALES_PATH,
  //       label: " Sales Information",
  //       icon: <TrendingUpIcon sx={iconSx} />,
  //       permission: null,
  //     },
  //     {
  //       path: LEAD_REPORT_PAYMENT_SUMMARY_PATH,
  //       label: "Payment Summary",
  //       icon: <PaymentIcon sx={iconSx} />,
  //       permission: null,
  //     },
  //     {
  //       path: LEAD_REPORT_CLIENTS_AS_PER_STATUS_PATH,
  //       label: "Clients as per status",
  //       icon: <PieChartIcon sx={iconSx} />,
  //       permission: null,
  //     },
  //   ],
  // },
  {
    type: "group",
    label: "Calender & Meetings",
    icon: <CalendarMonthIcon sx={groupIconSx} />,
    children: [
      {
        path: CALENDAR_SCHEDULE_PATH,
        label: "Meetings",
        icon: <CalendarMonthIcon sx={iconSx} />,
        permission: "meeting-list",
      },
      {
        path: MEETING_CREATE_PATH,
        label: "Add Meeting",
        icon: <CalendarMonthIcon sx={iconSx} />,
        permission: "meeting-create",
      },
    ],
  },
  {
    type: "group",
    label: "E-Signature Contracts",
    icon: <DescriptionOutlinedIcon sx={groupIconSx} />,
    children: [
      {
        path: CONTRACTS_LIST_PATH,
        label: "Contracts",
        icon: <DescriptionOutlinedIcon sx={iconSx} />,
        permission: "eSignContract-list",
      },
    ],
  },

  {
    type: "group",
    label: "Invoices",
    icon: <ReceiptLongIcon sx={groupIconSx} />,
    children: [
      {
        path: INVOICES_LIST_PATH,
        label: "Invoices",
        icon: <ReceiptLongIcon sx={iconSx} />,
        permission: "invoice-list",
      },
      {
        path: INVOICES_CREATE_PATH,
        label: "Add invoice",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "invoice-create",
      },
    ],
  },

  {
    type: "group",
    label: "Payments",
    icon: <PaymentIcon sx={groupIconSx} />,
    children: [
      {
        path: PAYMENTS_LIST_PATH,
        label: "Payments",
        icon: <PaymentIcon sx={iconSx} />,
        permission: "payment-list",
      },
      {
        path: PAYMENT_ERRORS_LIST_PATH,
        label: "Payment errors",
        icon: <ErrorOutlineIcon sx={iconSx} />,
        permission: "payment-error-list",
      },
    ],
  },
  {
    type: "group",
    label: "Payments Accounts",
    icon: <PaymentIcon sx={groupIconSx} />,
    children: [
      {
        path: PAYMENT_ACCOUNTS_LIST_PATH,
        label: "Payment Accounts List",
        icon: <PaymentIcon sx={iconSx} />,
        permission: "payment-account-list-front",
      },
      {
        path: PAYMENT_ACCOUNTS_CREATE_PATH,
        label: "Add Payment Account",
        icon: <ErrorOutlineIcon sx={iconSx} />,
        permission: "payment-account-create",
      },
    ],
  },
  {
    type: "group",
    label: "Order Management",
    icon: <PaymentIcon sx={groupIconSx} />,
    children: [
      {
        path: ORDER_LIST_PATH,
        label: "Order",
        icon: <ErrorOutlineIcon sx={iconSx} />,
        permission: "order-list",
      },
      {
        path: ORDER_CREATE_PATH,
        label: "Create Order",
        icon: <PaymentIcon sx={iconSx} />,
        permission: "order-create",
      },
      // {
      //   path: UNKNOWN_PATH,
      //   label: "Unknown",
      //   icon: <ErrorOutlineIcon sx={iconSx} />,
      //   permission: "payment-error-list",
      // },
    ],
  },

  {
    type: "group",
    label: "Brands",
    icon: <StorefrontIcon sx={groupIconSx} />,
    children: [
      {
        path: BRANDS_LIST_PATH,
        label: "Brands",
        icon: <StorefrontIcon sx={iconSx} />,
        permission: "brand-list",
      },
      {
        path: BRANDS_CREATE_PATH,
        label: "Add brand",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "brand-create",
      },
    ],
  },
  {
    type: "group",
    label: "Services",
    icon: <HandymanIcon sx={groupIconSx} />,
    children: [
      {
        path: SERVICES_LIST_PATH,
        label: "Services",
        icon: <HandymanIcon sx={iconSx} />,
        permission: "service-list",
      },
      {
        path: SERVICES_CREATE_PATH,
        label: "Add service",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "service-create",
      },
    ],
  },
  {
    type: "group",
    label: "Service Plans",
    icon: <HandymanIcon sx={groupIconSx} />,
    children: [
      {
        path: SERVICE_PLANS_LIST_PATH,
        label: "Service Plans List",
        icon: <HandymanIcon sx={iconSx} />,
        permission: "service-plan-list",
      },
      {
        path: SERVICE_PLANS_CREATE_PATH,
        label: "Add service plan",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "service-plan-create",
      },
    ],
  },
  {
    type: "group",
    label: "Service State Price",
    icon: <HandymanIcon sx={groupIconSx} />,
    children: [
      {
        path: SERVICE_STATE_PRICES_LIST_PATH,
        label: "Service State Price List",
        icon: <HandymanIcon sx={iconSx} />,
        permission: "service-state-price-list",
      },
      {
        path: SERVICE_STATE_PRICES_CREATE_PATH,
        label: "Add service State Price",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "service-plan-create",
      },
    ],
  },

  {
    type: "group",
    label: "Companies",
    icon: <ApartmentIcon sx={groupIconSx} />,
    children: [
      {
        path: COMPANIES_LIST_PATH,
        label: "Companies",
        icon: <ApartmentIcon sx={iconSx} />,
        permission: "company-list-front",
      },
      {
        path: COMPANIES_CREATE_PATH,
        label: "Add company",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "company-create",
      },
    ],
  },

  {
    type: "group",
    label: "Task types",
    icon: <AssignmentIcon sx={groupIconSx} />,
    children: [
      {
        path: TASK_TYPES_LIST_PATH,
        label: "Task types",
        icon: <AssignmentIcon sx={iconSx} />,
        permission: "task-type-list",
      },
      {
        path: TASK_TYPES_CREATE_PATH,
        label: "Add task type",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "task-type-create",
      },
    ],
  },

  {
    type: "group",
    label: "Task categories",
    icon: <CategoryIcon sx={groupIconSx} />,
    children: [
      {
        path: TASK_CATEGORIES_LIST_PATH,
        label: "Task categories",
        icon: <CategoryIcon sx={iconSx} />,
        permission: "task-category-list",
      },
      {
        path: TASK_CATEGORIES_CREATE_PATH,
        label: "Add task category",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "task-category-create",
      },
    ],
  },

  {
    type: "group",
    label: "Task templates",
    icon: <DescriptionOutlinedIcon sx={groupIconSx} />,
    children: [
      {
        path: TASK_TEMPLATES_LIST_PATH,
        label: "Task templates",
        icon: <DescriptionOutlinedIcon sx={iconSx} />,
        permission: "task-template-list",
      },
      {
        path: TASK_TEMPLATES_CREATE_PATH,
        label: "Add task template",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "task-template-create",
      },
    ],
  },

  // {
  //   type: "group",
  //   label: "Tasks",
  //   icon: <EventNoteIcon sx={groupIconSx} />,
  //   children: [
  //     {
  //       path: TASKS_LIST_PATH,
  //       label: "Tasks",
  //       icon: <EventNoteIcon sx={iconSx} />,
  //       permission: "task-list",
  //     },
  //     {
  //       path: TASKS_CREATE_PATH,
  //       label: "Add task",
  //       icon: <AddCircleOutlineIcon sx={iconSx} />,
  //       permission: "task-create",
  //     },
  //   ],
  // },

  {
    type: "group",
    label: "User Management",
    icon: <PeopleOutlineIcon sx={groupIconSx} />,
    children: [
      {
        path: USERS_LIST_PATH,
        label: "Users",
        icon: <PeopleOutlineIcon sx={iconSx} />,
        permission: "user-list-front",
      },
      {
        path: CREATE_USER,
        label: "Add User",
        icon: <PersonOutlineIcon sx={iconSx} />,
        permission: "user-create",
      },
    ],
  },
  {
    type: "group",
    label: "Customer Management",
    icon: <BadgeOutlinedIcon sx={groupIconSx} />,
    children: [
      {
        path: CUSTOMERS_LIST_PATH,
        label: "Customers",
        icon: <BadgeOutlinedIcon sx={iconSx} />,
        permission: "customer-list-front",
      },
      {
        path: CREATE_CUSTOMER,
        label: "Add Customer",
        icon: <PersonOutlineIcon sx={iconSx} />,
        permission: "customer-create",
      },
    ],
  },
  {
    type: "group",
    label: "Team Management",
    icon: <SupervisorAccountIcon sx={groupIconSx} />,
    children: [
      {
        path: TEAMS_LISTS_PATH,
        label: "Teams",
        icon: <SupervisorAccountIcon sx={iconSx} />,
        permission: "team-list",
      },
      {
        path: CREATE_TEAM,
        label: "Add Team",
        icon: <SupervisorAccountIcon sx={iconSx} />,
        permission: "team-create",
      },
    ],
  },

  {
    type: "group",
    label: "Customer Support",
    icon: <SupportIcon sx={groupIconSx} />,
    children: [
      {
        path: ISSUE_LIST_PAGE,
        label: "Issue Tracking",
        icon: <CalendarMonthIcon sx={iconSx} />,
        permission: "issue-list",
      },
    ],
  },

  {
    type: "group",
    label: "Roles Permission Management",
    icon: <AdminPanelSettingsIcon sx={groupIconSx} />,
    children: [
      {
        path: ROLES_LIST_PATH,
        label: "Roles",
        icon: <AdminPanelSettingsIcon sx={iconSx} />,
        permission: "role-view",
      },
      {
        path: ROLES_CREATE_PATH,
        label: "Add role",
        icon: <AddCircleOutlineIcon sx={iconSx} />,
        permission: "role-create",
      },
      {
        path: USER_PERMISSION,
        label: "User Access Control",
        icon: <CalendarMonthIcon sx={iconSx} />,
        permission: "user-direct-permission",
      },
    ],
  },
];

/** Flat list of all items (for backward compatibility) */
export const sidebarItems = sidebarStructure.flatMap((entry) => {
  if (entry.type === "item") return [entry];
  if (entry.type === "group")
    return entry.children.map((c) => ({
      ...c,
      path: c.path,
      label: c.label,
      icon: c.icon,
      permission: c.permission,
    }));
  return [];
});

export const getFilteredSidebarItems = (userPermissions = []) => {
  const norm = (p) =>
    (p || "").toLowerCase().replace(/\s+/g, "-").replace(/_/g, "-");
  const normalizedUser = new Set((userPermissions || []).map(norm));
  const hasAny = (perms) => perms.some((p) => normalizedUser.has(norm(p)));

  return sidebarItems.filter((item) => {
    if (item.permission === null || item.permission === undefined) return true;
    const anyPerms = LIST_ROUTE_ANY_PERMISSIONS[item.path];
    if (anyPerms) return hasAny(anyPerms);
    if (!item.permission) return true;
    return normalizedUser.has(norm(item.permission));
  });
};
